import BillSwitchProductIntroScreen from 'features/billSwitch/screens/BillSwitchProductIntroScreen/BillSwitchProductIntroScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function BillSwitchProductIntroPage() {
  return (
    <PinwheelContextProvider>
      <BillSwitchProductIntroScreen />
    </PinwheelContextProvider>
  );
}
